import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SidebarModal } from '../../../../../components/common/Sidebar/Sidebar';
import { UserStatuses } from './UserStatuses';

import { Tab, FlexJustifyCenter } from './UserVerification.styles';

export const UserVerifications = ({ teamMember }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation('myTeam');
  return (
    <>
      <FlexJustifyCenter>
        {teamMember?.isUserNotVerified && (
          <Tab
            onClick={() => {
              setIsOpen(!isOpen);
            }}>
            {t('user_not_verified')}
          </Tab>
        )}
        {/* {teamMember?.hasNoPackage && (
          <Tab
            onClick={() => {
              setIsOpen(!isOpen);
            }}>
            {t('no_staking_hub_order')}
          </Tab>
        )} */}
        {/* {teamMember?.hasUnpaidPackage && (
          <Tab
            onClick={() => {
              setIsOpen(!isOpen);
            }}>
            {t('waiting_payment')}
          </Tab>
        )} */}
        {teamMember?.isNotQualifiedPartner && (
          <Tab
            onClick={() => {
              setIsOpen(!isOpen);
            }}>
            {t('not_qualified_rank')}
          </Tab>
        )}
      </FlexJustifyCenter>

      <SidebarModal
        isOpen={isOpen}
        setOpen={setIsOpen}
        title={'User Statuses'}
        sidebarWidth={'511px'}>
        <UserStatuses setIsOpen={setIsOpen} />
      </SidebarModal>
    </>
  );
};
